import { SocketClient } from "cbcore-ts"
import type { TextContentBlock } from "openai/resources/beta/threads"
import * as showdown from "showdown"
import { nil, UIColor, UINativeScrollView, UIRoute, UITextField, UITextView, UIView, UIViewController } from "uicore-ts"
import { RHCore } from "./Core/RHCore"
import { CBButton } from "./Custom components/CB/CBButton"
import { CBDialogViewShower } from "./Custom components/CB/CBDialogViewShower"
import { RHTextSanitizer } from "./Custom components/RH/Utils_slop/RHTextSanitizer"


const markdownConverter = new showdown.Converter()


export class ChatGPTViewController extends UIViewController {
    
    readonly titleLabel: UITextView = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "Hankeseaduste robot",
        hoverText: "",
        backgroundColor: UIColor.transparentColor
    }).addedAsSubviewToView(this.view)
    explanationLabel: UITextView = new UITextView().addedAsSubviewToView(this.view).configuredWithObject({
        text: "Selle roboti käest võib küsida hankeid puudutavate seaduste kohta"
    })
    messagesScrollView: UINativeScrollView = new UINativeScrollView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            backgroundColor: UIColor.transparentColor,
            style: {
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: UIColor.blackColor.stringValue,
                padding: this.core.paddingLength * 0.5 + "px"
            }
        })
    chatTextField: UITextField = new UITextField().addedAsSubviewToView(this.view).configuredWithObject({
        text: "",
        viewHTMLElement: { autocomplete: "off" },
        placeholderText: "Küsi siin küsimus",
        style: {
            padding: this.core.paddingLength * 0.5 + "px"
        },
        controlEventTargetAccumulator: {
            EnterDown: (_sender, event) => {
                this.sendMessageButton.sendControlEventForKey(CBButton.controlEvent.EnterDown, event)
            }
        }
    })
    sendMessageButton: CBButton = new CBButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Saada sõnum"
        },
        controlEventTargetAccumulator: {
            PrimaryActionTriggered: async () => {
                
                const messageText = this.chatTextField.text
                if (!messageText) {
                    return
                }
                
                this.chatTextField.text = ""
                
                const userName = this.usernameFromRoute || RHCore.sharedInstance.userProfile
                    ?.contactInformation?.name || "Kasutaja"
                this.messagesScrollView.viewHTMLElement.innerHTML = this.messagesScrollView.viewHTMLElement.innerHTML +
                    "<span style=\"font-weight: bold\" class=\"UserMessageAuthorName\"> " +
                    RHTextSanitizer.escapedHTML(userName) + ": </span> " +
                    "<span class=\"UserMessageText\">" +
                    RHTextSanitizer.sanitizedHTML(markdownConverter.makeHtml(messageText)) + "</span> " +
                    "<br>"
                
                this.messagesScrollView.setNeedsLayoutUpToRootView()
                this.messagesScrollView.scrollToBottom()
                
                CBDialogViewShower.showActionIndicatorDialog("Processing")
                
                const chatGPTResponse = await SocketClient.ChatGPTResponseBySendingMessage({
                    threadID: this.threadID,
                    messageText: messageText
                })
                
                this.threadID = chatGPTResponse.result.threadID
                
                const messages = chatGPTResponse.result.threadMessages
                
                CBDialogViewShower.hideActionIndicatorDialog()
                console.log(messages)
                
                let innerHTML = ""
                for (const message of messages.reverse()) {
                    
                    const userName = {
                        user: this.usernameFromRoute || RHCore.sharedInstance.userProfile?.contactInformation.name || "Kasutaja",
                        assistant: "Robot"
                    }[message.role]
                    innerHTML = innerHTML + "<span style=\"font-weight: bold\" class=\"RobotMessageAuthorName\"> " +
                        RHTextSanitizer.escapedHTML(userName) + ": </span> " +
                        "<span class=\"RobotMessageText\">" + message.content.map(content => {
                            if ((content as TextContentBlock).text) {
                                return RHTextSanitizer.sanitizedHTML(
                                    markdownConverter.makeHtml((content as TextContentBlock).text.value)
                                )
                            }
                            return ""
                        }).join(" ") + "</span> " +
                        "<br>"
                    
                    
                }
                
                this.messagesScrollView.viewHTMLElement.innerHTML = innerHTML
                this.messagesScrollView.setNeedsLayoutUpToRootView()
                this.messagesScrollView.scrollToBottom()
                
            }
        }
    })
    bottomView = new UIView().addedAsSubviewToView(this.view)
    threadID?: string
    
    usernameFromRoute?: string
    
    
    constructor(view: UIView) {
        
        super(view)
        // Code for further setup if necessary
        
        this.view.configureWithObject({
            backgroundColor: UIColor.whiteColor,
            hoverText: ""
        })
        
        
    }
    
    
    static override readonly routeComponentName = "chatgpt"
    static override readonly ParameterIdentifierName = {}
    
    
    override async viewDidAppear() {
        
        await super.viewDidAppear()
        
        this.chatTextField.focus()
        
        var asd = await SocketClient.ChatGPTThreadsForCurrentUser(null)
        
        console.log(asd.responseMessage)
        
        
    }
    
    override async handleRoute(route: UIRoute) {
        
        super.handleRoute(route)
        
        this.usernameFromRoute = route.componentWithName("user")?.parameters.name ?? this.usernameFromRoute
        
        this.titleLabel.text = "Hankeseaduste robot (Kasutaja nimi: " +
            RHTextSanitizer.escapedHTML(
                this.usernameFromRoute ??
                RHCore.sharedInstance.userProfile?.contactInformation.name ??
                ""
            ) +
            ")"
        
    }
    
    
    override layoutViewSubviews() {
        
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding
        
        // View bounds
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        this.titleLabel.frame = bounds.rectangleWithHeight(labelHeight * 2)
        this.explanationLabel.frame = this.titleLabel.frame.rectangleForNextRow(
            padding,
            [this.explanationLabel.intrinsicContentHeight(this.titleLabel.frame.width), padding].max()
        )
        this.messagesScrollView.frame = this.explanationLabel.frame.rectangleForNextRow(
            padding,
            [
                [
                    this.messagesScrollView.intrinsicContentHeight(this.explanationLabel.frame.width),
                    padding,
                    200
                ].max(),
                700,
                UIView.pageHeight - 350
            ].min()
        )
        this.messagesScrollView.frame.rectangleForNextRow(
            padding,
            labelHeight * 2
        ).distributeViewsAlongWidth(
            [this.chatTextField, this.sendMessageButton],
            1,
            padding,
            [nil, this.sendMessageButton.titleLabel.intrinsicContentWidth(labelHeight * 2) + padding * 2]
        )
        this.chatTextField.frame = this.chatTextField.frame.rectangleWithHeight(labelHeight * 1.5, 0.5)
        this.bottomView.frame = this.sendMessageButton.frame.rectangleForNextRow(0, padding)
        
        
    }
}


